module.exports = __webpack_public_path__ + "media/pricing/DigitalStorage-x2-546c9e1b.png";